import { axiosInstance as Send } from '../axiosInstance'
import { TokenDetailRes, TokenListRes } from './response'

import { responseType } from '../type'
import config from '../../config'
import constants from '../../constants'

export const getTokenList = async (pageNumber: number, pageSize: number): Promise<responseType<TokenListRes>> => {
  const url = `${constants.prefix}/${constants.versioning}/token/list?pageNumber=${pageNumber}&pageSize=${pageSize}`
  return Send.get<responseType<TokenListRes>>(`${config.EXPLORER_BACKEND_URL + url}`).then((response) => response.data)
}

export const getTokenDetail = async (address: string): Promise<responseType<TokenDetailRes>> => {
  const url = `${constants.prefix}/${constants.versioning}/token/${address}`
  return Send.get<responseType<TokenDetailRes>>(`${config.EXPLORER_BACKEND_URL + url}`).then(
    (response) => response.data,
  )
}
